import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import Stops from '../../components/stops/Stops'
import Footer from '../../components/common/Footer'
export default function StopPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <Stops/>
            <Footer/>
        </>
    )
}